import type { QueryStoreProps } from "./List.js";
import { type DataKey, type Database, getString } from "shelving";
import { ASIDE } from "../base/Aside.js";
import { Icon } from "../base/Icon.js";
import { wrapText } from "../util/react.js";
import { PaginateButton } from "./PaginateButton.js";

/** Output a paginated set of results as a grid. */
export function Grid<T extends Database, K extends DataKey<T>>({
	mods = "", //
	after = null,
	before = null,
	store,
	empty = `No ${store.collection}s`,
	more,
	detect,
	mapper,
}: QueryStoreProps<T, K>): React.ReactElement | null {
	const { value, hasMore } = store;
	return value.length ? (
		<section className={`grid ${mods}`}>
			{before}
			{value.map(mapper)}
			{after}
			{more !== null && hasMore ? (
				<PaginateButton store={store} detect={detect} title={getString(more)} mods="button-quiet">
					<Icon icon="more" />
				</PaginateButton>
			) : null}
		</section>
	) : (
		wrapText(empty, ASIDE)
	);
}
